import { render, staticRenderFns } from "./game-fps.vue?vue&type=template&id=12ecf762&scoped=true&"
import script from "./game-fps.vue?vue&type=script&lang=js&"
export * from "./game-fps.vue?vue&type=script&lang=js&"
import style0 from "./game-fps.vue?vue&type=style&index=0&id=12ecf762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ecf762",
  null
  
)

export default component.exports